module.exports = __webpack_public_path__ + "static/media/white@3x.45e81f9f.png";